<div class="select-home-container tw-w-[13rem] 2xl:tw-w-[16rem]">
    <div
        class="select-home tw-pb-[0.5rem] tw-flex tw-gap-2 tw-items-center tw-text-black tw-text-[12px] tw-font-semibold tw-mb-[5px]"
    >
        {{ label }}
        <span class="tw-text-red-400" *ngIf="mandatoryField === true">*</span>
    </div>
    <div
        class="wrapper-dropdown tw-flex tw-pb-[0.5rem] tw-items-center tw-justify-between tw-px-2"
        id="dropdown"
        (click)="toggleDropdown(!isDropdownOpen)"
    >
        <span
            class="selected-display tw-text-[2rem] tw-font-semibold tw-text-gray-400"
            >{{ getCurrentLabel() }}</span
        >
        <mat-icon aria-label="home icon" fontIcon=""
            >keyboard_arrow_down</mat-icon
        >
        <ul class="dropdown" *ngIf="isDropdownOpen">
            <li
                class="item"
                *ngFor="let option of options"
                (click)="selectOption(option.value)"
            >
                {{ option.label }}
            </li>
        </ul>
    </div>
</div>
